module.exports = "pegasus/assets/preview-14.png";